import {
    CREATE_SUPPORT_TICKET_REQUEST,
    CREATE_SUPPORT_TICKET_SUCCESS,
    CREATE_SUPPORT_TICKET_FAILURE,

    GET_SUPPORT_TICKETS_REQUEST,
    GET_SUPPORT_TICKETS_SUCCESS,
    GET_SUPPORT_TICKETS_FAILURE,
} from "../actions/types";

const initialState = {
    tickets: [],
    ticket: null,

    total: 0,
    page: 1,
    pages: 1,
    size: 10,

    loading: false,
    creating: false,
    deleting: false,

    error: null,
};

const supportReducer = (
    state = initialState,
    action
) => {
    switch (
        action.type
    ) {
        case CREATE_SUPPORT_TICKET_REQUEST:
            return {
                ...state,
                creating: true,
                error: null,
            };

        case CREATE_SUPPORT_TICKET_SUCCESS:
            return {
                ...state,
                creating: false,
                tickets: [
                    action.payload,
                    ...state.tickets,
                ],
            };

        case CREATE_SUPPORT_TICKET_FAILURE:
            return {
                ...state,
                creating: false,
                error:
                    action.payload,
            };

        case GET_SUPPORT_TICKETS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case GET_SUPPORT_TICKETS_SUCCESS:
            return {
                ...state,
                loading: false,
                tickets:
                    action.payload
                        ?.data || [],
                total:
                    action.payload
                        ?.total || 0,
                page:
                    action.payload
                        ?.page || 1,
                pages:
                    action.payload
                        ?.pages || 1,
                size:
                    action.payload
                        ?.size || 10,
            };

        case GET_SUPPORT_TICKETS_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

        default:
            return state;
    }
};

export default supportReducer;